import React, { useContext, useEffect, useState } from "react";
import { FaRegCalendarAlt, FaRegClock, FaSun, FaMoon } from "react-icons/fa";
import { numero_table } from "../../../ApiServices/Horoscope/BirthDetailsApi";
import { GetProfileDetails, GetUserModel } from "../../../ApiServices/Profile/ProfileApi";
import Breadcrumbs from "../../Breadcrumb";
import HoroscopeBannerImg from "../../../assets/images/new/HoroscopeBanner.png";
import astroBackgroundImg from "../../../assets/images/Horoscope/horoscopeBackgroundImg.png";
import dayjs from "dayjs";
import { LoaderContext } from "../../../AuthContext/AuthContext";
import astrology from "../../../assets/images/new/astrology.png";
import panchang from "../../../assets/images/new/panchang.png";
import numerology from "../../../assets/images/new/numerology.png";
import zodiacSign from "../../../assets/images/new/zodiacSign.png";
import Astro from "../../../assets/images/new/services1 (1).jpg";
import Panchang from "../../../assets/images/new/services1 (2).jpg";
import NumerologyImage from "../../../assets/images/new/services1 (3).jpg";
import AstrologyIo from "../../../assets/images/new/astrologer.png";
import AstrologyIt from "../../../assets/images/new/earth.png";
import AstrologyItone from "../../../assets/images/new/earthone.png";
import AstrologyIf from "../../../assets/images/new/solar.png";
import Prediction from "../../../assets/images/new/services1 (3).jpg";
import Pridictions from "../../../assets/images/new/astrologerone.png";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorMassagePupUp from "../../ErrorMassagePupUp";
const Numerology = () => {
  const { setLoader, pujaStatus } = useContext(LoaderContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [customErrorMassage, setCustomErrorMassage] = useState("")

  const [numeroLogyList, setNumeroLogyList] = useState({
    name: null,
    dob: null,
    destinyNumber: null,
    radicalNumber: null,
    nameNumber: null,
    evilNumber: null,
    favNumber: null,
    favDay: null,
    favGod: null,
    favMantra: null,
    favColor: null,
    favMetal: null,
    favStone: null,
    favSubStone: null,
    friendlyNumber: null,
    neutralNumber: null,
    radicalRular: null,
  });
  const categories = [
    {
      title: "Astrology",
      image: Astro,
      icon: astrology,
      text: "Book Astrology for your spiritual rituals and ceremonies.",
      color: "#ffa415",
      route: "/basic-details",
    },
    {
      title: "Panchang",
      image: Panchang,
      icon: panchang,
      text: "Get a Panchang for your up and down ",
      color: "#fc5528",
      route: "/daily-panchang",
    },
    {
      title: "Numerology",
      image: NumerologyImage,
      icon: numerology,
      text: "Numerology for better life",
      color: "#8139e7",
      route: "/numerology",
    },
    {
      title: "Zodiac Signs",
      image: Prediction,
      icon: zodiacSign,
      text: "Know about Prediction",
      color: "#399be7",
      route: "/Prediction ",
    },
  ];
  useEffect(() => {
    GetUserModelData();
  }, []);
  const GetUserModelData = async () => {
    setLoader(true);

    const userKeyID = localStorage.getItem("userKeyID");
    try {
      const response = await GetProfileDetails(userKeyID);
      if (response?.statusCode === 200) {
        setLoader(false);
        const ModelData = response?.responseData?.data || []; // Assuming the data is an array and we need the first item

        const dob = new Date(ModelData?.dob);

        const year = dob.getFullYear();
        const month = dob.getMonth() + 1; // Months are zero-based (0 = January)
        const day = dob.getDate();

        const [hours, minutes] = ModelData?.tob.split(":");
        const apiParam = {
          day: day,
          month: month,
          year: year,
          name: ModelData?.userName,
        };

        await GetNumberDetails(apiParam, dayjs(dob).format("DD/MM/YYYY"));
      } else {
        setLoader(false);

        console.error(
          "Error fetching data: ",
          response?.data?.data?.statusCode
        );
      }
    } catch (error) {
      setLoader(false);

      console.error("Error", error);
    }
  };
  const GetNumberDetails = async (apiParam, DATE) => {
    setLoader(true);
    try {
      const response = await numero_table(apiParam);
      if (response !== null && response !== undefined) {
        setLoader(false);

        setNumeroLogyList((prev) => ({
          ...prev,
          name: response?.name,
          date: DATE,
          destinyNumber: response?.destiny_number,
          radicalNumber: response?.radical_number,
          nameNumber: response?.name_number,
          evilNumber: response?.evil_num,
          favColor: response?.fav_color,
          favDay: response?.fav_day,
          favGod: response?.fav_god,
          favMantra: response?.fav_mantra,
          favMetal: response?.fav_metal,
          favStone: response?.fav_stone,
          favSubStone: response?.fav_substone,
          friendlyNumber: response?.friendly_num,
          neutralNumber: response?.neutral_num,

          radicalRular: response?.radical_ruler,
        }));
      } else {
        setLoader(false);

        console.error("Error fetching data: ", response);
      }
    } catch (error) {
      setLoader(false);
      setCustomErrorMassage(error?.response?.data?.msg)
      setShowErrorModal(true)
      console.error("Error", error);
    }
  };

  const HandleCloseModal = () => {
    setShowErrorModal(false)
    navigate("/")
  }
  return (
    <>

      <section className="about-one">
        {/* Shape */}
        <div className="about-one__shape">
          <img src="assets/images/shapes/about-1-shape-4.png" alt="careox" />
        </div>

        <div className="container">
          <div className="row">
            {/* Left Image Section */}


            {/* Right Content Section */}
            <div className="col-xl-5 wow fadeInRight" data-wow-delay="200ms">
              <div className="about-one__content">
                {/* Section Title */}

                {/* Two Boxes */}
                <div className="row gutter-y-30">
                  <div className="col-md-12">
                    <div
                      className="about-one__content__box"
                      style={{ "--accent-color": "#ffa415" }}
                    >
                      <div className="about-one__content__box__top">
                        <div className="about-one__content__box__icon">
                          <img src={AstrologyIf} alt="Zakat Icon" />
                        </div>
                        <h5 className="about-one__content__box__title">
                          Numerology Details
                        </h5>
                      </div>
                      <div className="about-one__content__border"></div>
                      <div className="row gutter-y-30">
                        <div className="col-md-6">
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Name :</b> {numeroLogyList?.name}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Destiny Number :</b> {numeroLogyList?.destinyNumber || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Radical Number :</b> {numeroLogyList?.radicalNumber || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Name Number :</b> {numeroLogyList?.nameNumber || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Evil Number :</b> {numeroLogyList?.evilNumber || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Favorite Color :</b> {numeroLogyList?.favColor || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Favorite Day :</b> {numeroLogyList?.favDay || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Favorite God :</b> {numeroLogyList?.favGod || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Favorite Mantra :</b> {numeroLogyList?.favMantra || '-'}
                          </p>
                        </div>
                        <div className="col-md-6 pointer-panchang">
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Favorite Metal :</b> {numeroLogyList?.favMetal || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Favorite Stone :</b> {numeroLogyList?.favStone || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Favorite Substone :</b> {numeroLogyList?.favSubStone || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Friendly Number :</b> {numeroLogyList?.friendlyNumber || '-'}
                          </p>
                          <p className="about-one__content__box__text">
                            <span className="about-one__content__box__text__icon">
                              <i className="icofont-check-circled"></i>
                            </span>
                            <b>Neutral Number :</b> {numeroLogyList?.neutralNumber || '-'}
                          </p>

                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-md-6">
                  <div
                    className="about-one__content__box"
                    style={{ "--accent-color": "#ff5528" }}
                  >
                    <div className="about-one__content__box__top">
                      <div className="about-one__content__box__icon">
                        <span className="icon-charity"></span>
                      </div>
                      <h5 className="about-one__content__box__title">Help Raising</h5>
                    </div>
                    <p className="about-one__content__box__text">
                      <span className="about-one__content__box__text__icon">
                        <i className="icofont-check-circled"></i>
                      </span>
                      No matter what you you have.
                    </p>
                  </div>
                </div> */}
                </div>
              </div>
            </div>
            <div className="col-xl-7">
              <div
                className="about-one__image wow fadeInLeft"
                data-wow-delay="100ms"
              >
                <div className="about-one__image__one  main-design">
                  <img src={Pridictions} alt="careox" />
                </div>
                <div className="about-one__image__two">
                  {/* <img src={AstrologyIt} alt="careox" /> */}
                </div>
                <div className="about-one__image__shape-one sub-design">
                  <img src={AstrologyItone} alt="careox" />
                </div>


              </div>
            </div>
          </div>

          {/* Bottom Text */}
        </div>
      </section>

      <ErrorMassagePupUp show={showErrorModal} onHide={() => HandleCloseModal()} Massage={customErrorMassage} />
    </>
  );
};

export default Numerology;
